<template>
    <div :class="$style.setting" v-loading="loading" v-if="!loading">
        <page-header
            size="full"
            :class="$style.header"
            :visibleBack="true"
            :hasBorder="true"
            :backText="backText"
            :title="$t('goals.create_goal_title')"
            @back="handleBackClick"
        >
            <div ref="headerTools" :class="$style['header-tools']" slot="rightTools">
                <pt-icon
                    @click="toggleDialogVisible('description', !dialogVisible.description)"
                    icon="icon-recommend"
                    :icon-style="{
                        width: '24px',
                        height: '24px'
                    }"
                ></pt-icon>
                <pt-button size="medium" :disabled="!validGoalSetting" @click="handleTestSaveClick">
                    {{ $t('common.button_save') }}
                </pt-button>
            </div>
        </page-header>
        <div
            class="x-wrap x-wrap--full"
            :class="$style.description"
            v-show="dialogVisible.description"
        >
            <div :class="$style['description-arrow']" :style="descriptionArrowStyle"></div>
            <div :class="$style['description-container']">
                <pt-icon
                    :class="$style['description-close']"
                    @click="toggleDialogVisible('description', false)"
                    icon="pt-icon--close"
                    :icon-style="{
                        width: '16px',
                        height: '16px'
                    }"
                ></pt-icon>
                <div :class="$style['description-icon']">
                    <img src="@assets/images/goal/goal-add.png" />
                </div>
                <div :class="$style['description-info']">
                    <h3>{{ $t('goals.new_title') }}</h3>
                    <p>{{ $t('goals.new_description') }}</p>
                </div>
            </div>
        </div>
        <div :class="$style.container">
            <div class="x-wrap x-wrap--full">
                <div :class="$style.box">
                    <h4>{{ $t('goals.name') }}</h4>
                    <div :class="$style['box-content']">
                        <pt-input
                            :class="$style['box-ipt']"
                            size="large"
                            :placeholder="$t('goals.untitled_goal')"
                            v-model.trim="model.name"
                        ></pt-input>
                    </div>
                    <pt-button
                        type="text"
                        color="black"
                        v-if="model.description === null"
                        @click="handleDescriptionClick"
                        >+{{ $t('users.users_description') }}</pt-button
                    >
                </div>
                <div :class="$style.box" v-if="model.description !== null">
                    <h4>{{ $t('users.users_description') }}</h4>
                    <div :class="$style['box-content']">
                        <pt-input
                            :class="[$style['box-ipt'], $style['box-textarea']]"
                            type="textarea"
                            size="large"
                            :rows="2"
                            v-model="model.description"
                        ></pt-input>
                    </div>
                </div>
                <div :class="$style.box">
                    <h4>{{ $t('goals.define_goal') }}</h4>
                    <p>{{ $t('goals.define_goal_description') }}</p>
                    <div :class="$style['box-content']">
                        <div :class="$style.type">
                            <el-select
                                size="small"
                                v-model="model.content.type"
                                :placeholder="$t('common.select_placeholder')"
                                @change="goalTypeChange"
                            >
                                <el-option
                                    v-for="item in goalTypeList"
                                    :key="item.code"
                                    :label="item.text"
                                    :value="item.code"
                                >
                                </el-option>
                            </el-select>
                        </div>

                        <template v-if="model.content.type === 'url'">
                            <div :class="[$style.content_item, $style.type]">
                                <el-select
                                    size="small"
                                    v-model="model.content.condition"
                                    :placeholder="$t('common.select_placeholder')"
                                    @change="goalConditionChange"
                                >
                                    <el-option
                                        v-for="condition in goalConditionList"
                                        :key="condition.value"
                                        :label="condition.text"
                                        :value="condition.value"
                                    ></el-option>
                                </el-select>
                            </div>
                            <div
                                :class="[$style.content_item, $style.content_item_pagetype]"
                                v-if="
                                    model.content.condition &&
                                    !originalPatternList.includes(model.content.condition)
                                "
                            >
                                <el-select
                                    size="small"
                                    v-model="model.content.subType"
                                    :placeholder="$t('common.select_placeholder')"
                                    @change="subTypeChange"
                                >
                                    <el-option
                                        v-for="item in pageTypeList"
                                        :key="item.code"
                                        :label="item.name"
                                        :value="item.code"
                                    >
                                        <span :title="$t(item.name)">{{ $t(item.name) }}</span>
                                        <el-tooltip placement="top" :enterable="false">
                                            <div slot="content" v-html="$t(item.tip)"></div>
                                            <pt-icon
                                                icon="pt-icon--help-new"
                                                :icon-style="{
                                                    width: '16px',
                                                    height: '16px',
                                                    fill: '#344563',
                                                    'margin-left': '4px',
                                                    'vertical-align': 'text-bottom'
                                                }"
                                            ></pt-icon>
                                        </el-tooltip>
                                    </el-option>
                                </el-select>
                            </div>
                            <div
                                :class="[$style.content_item, $style.content_item_value]"
                                ref="conditionRef"
                            >
                                <ItemMultiSelectWithPopover
                                    class="pageSection"
                                    v-if="
                                        ['[()]', '=='].includes(model.content.condition) &&
                                        model.content.subType === 'page'
                                    "
                                    :data="model.content"
                                    :tag-placeholder="$t('common.or')"
                                    :value="model.content.value"
                                    :options="pageDictData"
                                    :trim-space="true"
                                    :allow-empty="false"
                                    :allow-create="true"
                                    :blur-create="true"
                                    @toggle="handleToggle"
                                    @change="data => goalValueChange(data.val)"
                                >
                                </ItemMultiSelectWithPopover>
                                <ItemMultiSelectWithPopover
                                    class="combinedPageSection"
                                    v-else-if="
                                        ['[()]', '=='].includes(model.content.condition) &&
                                        model.content.subType === 'combinedPage'
                                    "
                                    :data="model.content"
                                    :tag-placeholder="$t('common.or')"
                                    :value="model.content.value"
                                    :options="combinedPageDictData"
                                    :trim-space="true"
                                    :allow-empty="false"
                                    :allow-create="true"
                                    :blur-create="true"
                                    @toggle="handleToggle"
                                    @change="data => goalValueChange(data.val)"
                                >
                                </ItemMultiSelectWithPopover>
                                <el-input
                                    v-else
                                    v-model="model.content.value[0]"
                                    size="small"
                                    @change="goalValueChange"
                                ></el-input>
                            </div>
                        </template>
                        <template v-else>
                            <el-autocomplete
                                size="small"
                                :class="[$style.content_item, $style.content_item_value]"
                                v-model="model.content.value[0]"
                                clearable
                                value-key="code"
                                :placeholder="$t('common.select_placeholder')"
                                :fetch-suggestions="querySearchEvent"
                                @change="goalValueChange"
                                @select="goalValueChange"
                            ></el-autocomplete>
                            <el-tooltip :disabled="canAddSubject">
                                <template #content>
                                    <div
                                        class="subject-tips"
                                        v-html="$t('placeholder.add_event_property')"
                                    ></div>
                                </template>
                                <div
                                    :class="[
                                        $style.buttonFilter,
                                        !canAddSubject && $style.disabled
                                    ]"
                                    v-if="canAddEventVariant"
                                    @click.prevent="handleAddEventVariant"
                                >
                                    <pt-icon
                                        icon="pt-icon-addfilter"
                                        :style="{
                                            width: '20px',
                                            height: '20px'
                                        }"
                                    ></pt-icon>
                                </div>
                            </el-tooltip>

                            <!-- aggregateType -->
                            <div :class="$style.type">
                                <el-select
                                    size="small"
                                    v-model="model.content.aggregateType"
                                    :placeholder="$t('common.select_placeholder')"
                                    @change="handleAggregateTypeChange"
                                >
                                    <el-option
                                        v-for="item in aggregateTypeList"
                                        :key="item.code"
                                        :label="item.text"
                                        :value="item.code"
                                        :disabled="item.disabled"
                                    >
                                        <el-tooltip
                                            v-if="item.disabled && item.disabledTip"
                                            :content="item.disabledTip"
                                            placement="bottom"
                                            :enterable="false"
                                            :style="{ maxWidth: '200px' }"
                                        >
                                            <span :class="$style.disabledOption">{{
                                                item.text
                                            }}</span>
                                        </el-tooltip>
                                        <span v-else>{{ item.text }}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- aggregateProperty -->
                            <div
                                :class="[$style.content_item, $style.aggregatePropertySelect]"
                                v-if="showAggregatePropertySelect"
                            >
                                <el-select
                                    size="small"
                                    v-model="model.content.aggregateProperty"
                                    :placeholder="$t('goals.select_aggregate_property_placeholder')"
                                    clearable
                                >
                                    <el-option
                                        v-for="item in numberTypeEventProperties"
                                        :key="item.key"
                                        :label="item.name"
                                        :value="item.key"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </template>
                    </div>

                    <!-- 事件属性 当选择goal type 类型为event时才有 -->
                    <div
                        v-if="
                            model.content.type === 'event' &&
                            model.content.value[0] &&
                            model.content.where
                        "
                        aria-label="subjects"
                        :class="[
                            $style.subjects,
                            !!model.content.where.length && $style.hasSubjects
                        ]"
                    >
                        <div :class="$style.subjectsGap"></div>
                        <div :class="$style.subjectsContent">
                            <template
                                v-for="(item, index) in model.content.where"
                                v-if="currentEventProperties"
                            >
                                <goal-event-variant
                                    :index="index"
                                    :filter-len="model.content.where && model.content.where.length"
                                    :filter-items="currentEventProperties"
                                    :sid="profileInfo.sid"
                                    :timeZone="profileInfo.timeZone"
                                    :filter="item"
                                    :event-name="model.content.value[0]"
                                    :value-options="currentEventProperties"
                                    :property-value-options="eventPropertyValueOptions"
                                    @updateItems="handleCacheValueOptions"
                                    @change="val => handleUpdateWhere(index, val)"
                                    @delete="handleDeleteEventVariant(index)"
                                >
                                </goal-event-variant>
                                <div
                                    :class="$style.subjectsTag"
                                    v-if="index < model.content.where.length - 1"
                                >
                                    {{ $t('common.and') }}
                                </div>
                            </template>
                        </div>
                    </div>
                    <div :class="$style.rexTips" v-if="visibleRexTips">
                        <h3>{{ $t('goals.rex_tips_title') }}</h3>
                        <p v-html="$t('goals.rex_tips_content')"></p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 确认返回弹框-->
        <back-dialog
            v-if="dialogVisible.backDialog"
            @cancel="toggleDialogVisible('backDialog', false)"
            @confirm="handleConfirmBack"
        ></back-dialog>
        <!-- 更新goal的二次确认 -->
        <el-dialog
            center
            width="440px"
            :visible="updateGoalDialog"
            @close="updateGoalDialog = false"
        >
            <div class="dialog-content">
                <p class="des">{{ $t('goals.goal_update_tip') }}</p>
            </div>
            <div slot="footer" class="dialog-footer">
                <pt-button
                    class="pt-mr30"
                    type="outline"
                    color="black"
                    @click="updateGoalDialog = false"
                >
                    {{ $t('common.button_cancel') }}
                </pt-button>
                <pt-button @click="handleSaveClick">
                    {{ $t('common.button_confirm') }}
                </pt-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';
import PageHeader from '@/common/packages/page-header/PageHeader';
import GoalEventVariant from './GoalEventVariant.vue';
import BackDialog from './dialogs/BackDialog';
import ItemMultiSelectWithPopover from '@/components/users/setting/filter/items/item-multi-select-with-popover.vue';
import usersApis from '@/apis/users.apis';
import goalApis from '@/apis/goal.apis';
import commonUtils from '@common/utils/common.utils';
import { mapGetters, mapMutations } from 'vuex';
import settingConfig from '@/components/campaign/setting/setting.config';
import cloneUtils from '@common/utils/clone.utils';
import domUtils from '@/common/utils/dom.utils';
import permissionUtils from '@/common/utils/permission';
import PermissionConfig from '@/common/configs/permissions.config';
import analyticsService from '@/common/services/analytics.service';

export default {
    name: 'GoalsCreate',
    data() {
        const hasGoalRexPermission = permissionUtils.includePermissionWithStore([
            PermissionConfig.goalRex
        ]);
        const { originalPatternList, pageTypeList, entryPatternList } = settingConfig;
        const isCreated = this.$route.name === 'GoalsCreate';
        const dialogVisible = {
            backDialog: false,
            description: false
        };
        const goalTypeList = [
            {
                code: 'url',
                text: this.$t('campaign_settings.url')
            },
            {
                code: 'event',
                text: this.$t('campaign_settings.event')
            }
        ];
        const goalConditionList = entryPatternList.filter(item => {
            if (item.value === 'Rex') return hasGoalRexPermission;
            return !item.hide;
        });

        const defaultModel = {
            name: this.$t('goals.untitled_goal'),
            description: null,
            content: {
                type: 'url',
                subType: 'page',
                condition: '[()]',
                value: [],
                where: [],
                visiblePopover: false,
                htmlValue: '',
                visibleCount: 0,
                aggregateType: 'user',
                aggregateProperty: ''
            }
        };
        return {
            loading: false,
            isCreated,
            goalConditionList,
            goalTypeList,
            pageTypeList,
            originalPatternList,
            dialogVisible,
            from: this.$route.params.from,
            defaultModel,
            model: cloneUtils.deep(defaultModel),
            eventNameList: [],
            pageDictData: [],
            combinedPageDictData: [],
            currentEventProperties: null,
            eventPropertyOptions: {},
            eventPropertyValueOptions: {},
            isGoalChange: false,
            updateGoalDialog: false,
            withBandit: false
        };
    },
    created() {
        // 创建防抖版本的 fetchEventPropertyList，避免快速连续调用
        this.debouncedFetchEventPropertyList = debounce(this.fetchEventPropertyList, 300);
    },
    mounted() {
        this.isCreated = this.$route.name === 'GoalsCreate';
        if (!this.isCreated) this.fetchGoalSetting();
        // 不再预加载页面和组合页面数据，等真正需要时才请求
    },
    beforeDestroy() {
        // 取消防抖函数，防止内存泄漏
        if (this.debouncedFetchEventPropertyList) {
            this.debouncedFetchEventPropertyList.cancel();
        }
    },
    computed: {
        ...mapGetters('main', ['profileInfo', 'asideIsFolded', 'userInfo']),
        visibleRexTips() {
            const { type, condition } = this.model?.content || {};
            return type === 'url' && condition === 'Rex';
        },
        validGoalSetting() {
            const { name, content } = this.model;
            const { type, condition, value, where, aggregateType, aggregateProperty } = content;
            const baseValid =
                !!(name && Array.isArray(value) && value.length > 0 && value.join('') !== '') &&
                !where?.find(
                    w =>
                        w.error?.type ||
                        w.error?.value ||
                        !w.key ||
                        !w.value ||
                        w.value?.join('') === ''
                );
            // 当聚合类型为 sum 或 average 时，必须选择聚合属性
            const aggregateValid =
                aggregateType === 'user' ||
                (aggregateProperty && aggregateProperty !== '');
            return baseValid && aggregateValid;
        },
        backText() {
            const backToCampaignRouter = [
                'CampaignEdit',
                'CampaignCreate',
                'EngagementCreate',
                'EngagementEdit'
            ];
            return backToCampaignRouter.includes(this.from)
                ? this.$t('campaign_settings.back_to_campaign')
                : this.$t('goals.back_to_report');
        },
        descriptionArrowStyle() {
            return {
                right: this.$i18n.locale === 'EN' ? '84px' : '108px'
            };
        },
        canAddSubject() {
            return (
                this.model.content.value[0] &&
                this.currentEventProperties &&
                this.currentEventProperties.length > 0
            );
        },
        canAddEventVariant() {
            return !this.model.content.where || this.model.content.where.length <= 5;
        },
        showAggregatePropertySelect() {
            return ['sum', 'average'].includes(this.model.content.aggregateType);
        },
        numberTypeEventProperties() {
            if (!this.currentEventProperties) return [];
            return this.currentEventProperties.filter(item => item.type === 'NUMBER');
        },
        hasNumberTypeProperty() {
            return this.numberTypeEventProperties.length > 0;
        },
        aggregateTypeList() {
            const isUrlType = this.model.content.type === 'url';
            const isEventType = this.model.content.type === 'event';
            const hasSelectedEvent =
                isEventType &&
                this.model.content.value &&
                this.model.content.value[0] &&
                this.model.content.value[0] !== '';
            const hasNoEventSelected = isEventType && !hasSelectedEvent;
            const hasNoNumberProperty =
                isEventType && hasSelectedEvent && !this.hasNumberTypeProperty;

            // 判断 sum 和 average 是否应该禁用
            const shouldDisable = isUrlType || hasNoEventSelected || hasNoNumberProperty;

            // 获取禁用提示文本的辅助函数
            const getDisabledTip = aggregateType => {
                if (isUrlType) {
                    return this.$t('goals.aggregate_disabled_url_tip');
                } else if (hasNoEventSelected) {
                    return this.$t('goals.aggregate_disabled_no_event_tip');
                } else if (hasNoNumberProperty) {
                    const aggregateTypeText =
                        aggregateType === 'sum'
                            ? this.$t('goals.aggregate_type_sum_text')
                            : this.$t('goals.aggregate_type_average_text');
                    const aggregateTypeResult =
                        aggregateType === 'sum'
                            ? this.$t('goals.aggregate_result_sum')
                            : this.$t('goals.aggregate_result_average');
                    const aggregateTypeName =
                        aggregateType === 'sum'
                            ? this.$t('goals.aggregate_type_sum')
                            : this.$t('goals.aggregate_type_average');

                    return this.$t('goals.aggregate_disabled_no_number_tip', {
                        aggregateType: aggregateTypeName,
                        aggregateTypeText,
                        aggregateTypeResult
                    });
                }
                return '';
            };

            return [
                {
                    code: 'user',
                    text: this.$t('goals.aggregate_type_user'),
                    disabled: false
                },
                {
                    code: 'sum',
                    text: this.$t('goals.aggregate_type_sum'),
                    disabled: shouldDisable,
                    disabledTip: getDisabledTip('sum')
                },
                {
                    code: 'average',
                    text: this.$t('goals.aggregate_type_average'),
                    disabled: shouldDisable,
                    disabledTip: getDisabledTip('average')
                }
            ];
        }
    },
    watch: {
        'model.content.value': {
            handler(val) {
                (!val || val[0] === '') && this.$set(this.model.content, 'where', []);
                this.resetAggregateTypeIfNeeded();
            },
            deep: true
        },
        // 监听 NUMBER 类型属性的变化，当条件不满足时重置聚合类型
        numberTypeEventProperties: {
            handler() {
                this.resetAggregateTypeIfNeeded();
            },
            immediate: false
        },
        'model.content': {
            handler(val) {
                this.isGoalChange =
                    !this.isCreated &&
                    !isEqual(
                        {
                            condition: val?.condition,
                            subType: val?.subType,
                            type: val?.type,
                            value: val?.value,
                            where: val?.where,
                            aggregateType: val?.aggregateType,
                            aggregateProperty: val?.aggregateProperty
                        },
                        {
                            condition: this.defaultModel?.content?.condition,
                            subType: this.defaultModel?.content?.subType,
                            type: this.defaultModel?.content?.type,
                            value: this.defaultModel?.content?.value,
                            where: this.defaultModel?.content?.where,
                            aggregateType: this.defaultModel?.content?.aggregateType,
                            aggregateProperty: this.defaultModel?.content?.aggregateProperty
                        }
                    );
            },
            deep: true
        }
    },
    methods: {
        ...mapMutations('main', ['UPDATE_COUNTS', 'UPDATE_PACKAGE_USAGE']),
        fetchGoalSetting() {
            this.loading = true;
            const goalId = this.$route.params.goalId;
            goalApis
                .getGoal(null, {
                    where: {
                        id: goalId
                    }
                })
                .then(res => {
                    const { name, description, content, withBandit } = res;
                    this.withBandit = withBandit;
                    if (
                        content &&
                        ((this.originalPatternList.includes(content.condition) &&
                            content.subType) ||
                            !content.subType)
                    ) {
                        content.subType = 'page';
                    }

                    if (content && !content.where) {
                        content.where = [];
                    }

                    // 确保 content 包含所有必需的字段
                    const fullContent = {
                        ...content,
                        aggregateType: content?.aggregateType || 'user',
                        aggregateProperty: content?.aggregateProperty || ''
                    };

                    this.model = {
                        name,
                        description,
                        content: fullContent
                    };
                    this.defaultModel = cloneUtils.deep(this.model);
                    // 如果是事件类型，则需要请求事件列表
                    if (content && content.type === 'event') {
                        this.fetchEventList();
                        const eventName = content.value[0];
                        // const hasEventProperties = content.where && content.where.length > 0;
                        if (eventName && !this.eventPropertyOptions[eventName]) {
                            this.fetchEventPropertyList(eventName);
                        }
                    }
                    // 只有 url 类型的 goal 才需要处理 page/combinedPage 的 subType
                    if (
                        content.type === 'url' &&
                        (content.subType === 'page' || content.subType === 'combinedPage')
                    ) {
                        const htmlValue = domUtils.getConditionUrls(this.model.content);
                        this.$set(this.model.content, 'htmlValue', htmlValue);
                        this.$set(this.model.content, 'visiblePopover', false);
                        this.handleWord();

                        // 编辑模式下，如果已有值，需要预加载对应的字典数据以便正确回显
                        const hasValue = content.value && content.value.length > 0;
                        if (hasValue) {
                            if (content.subType === 'page' && this.pageDictData.length === 0) {
                                this.fetchDictData({
                                    funName: 'visitPage',
                                    propertyKey: 'page'
                                }).then(res => {
                                    const list = res.map(item => {
                                        return { code: item.key, name: item.key };
                                    });
                                    this.pageDictData = list;
                                });
                            } else if (
                                content.subType === 'combinedPage' &&
                                this.combinedPageDictData.length === 0
                            ) {
                                this.fetchDictData({
                                    funName: 'visitPage',
                                    propertyKey: 'combinedPage'
                                }).then(res => {
                                    const list = res.map(item => {
                                        return { code: item.key, name: item.key };
                                    });
                                    this.combinedPageDictData = list;
                                });
                            }
                        }
                    }
                    this.loading = false;
                });
        },
        handleTestSaveClick() {
            if (this.isGoalChange && !this.isCreated && this.withBandit) {
                this.updateGoalDialog = true;
            } else {
                this.handleSaveClick();
            }
        },
        handleSaveClick() {
            this.formatData();
            this.isCreated ? this.createGoal() : this.updateGoal();
        },
        sendAnalytics(content) {
            const hasEventProperty = content.type === 'event' && content.where?.length !== 0;

            if (hasEventProperty) {
                analyticsService
                    .usePTX('event_dimension', {
                        position: 'goal'
                    })
                    .track();
            }
        },
        createGoal() {
            const params = Object.assign({}, this.model, {
                sid: this.profileInfo.sid,
                createBy: this.userInfo.id
            });
            // 给保存的值去除前后空格
            params.content &&
                params.content.value &&
                Array.isArray(params.content.value) &&
                (params.content.value = params.content.value.map(item => {
                    return params.content.type === 'url' && typeof item === 'string'
                        ? item.trim()
                        : item;
                }));
            delete params.content?.htmlValue;
            delete params.content?.visibleCount;
            delete params.content?.visiblePopover;
            const { from, engageId } = this.$route.params;
            var e = this.from || this.$route.params?.back || 'GoalList';
            const ep = {
                GoalsEmpty: 'goal_onbo',
                GoalList: 'goal_list',
                CampaignCreate: 'cp_create_fromv2',
                EngagementCreate: 'cp_create_fromv1'
            };
            analyticsService
                .usePTX('goal_add_success', { position: ep[e], goal_type: params.content.type, aggregate_type: params.content.aggregateType })
                .track();
            this.sendAnalytics(params.content);
            goalApis.createGoal(null, { data: params }).then(
                res => {
                    typeof res?.count === 'number' &&
                        this.UPDATE_PACKAGE_USAGE({ type: 'goals', count: res.count });
                    this.UPDATE_COUNTS({
                        key: 'goalCount'
                    });
                    this.$router.push({
                        name: from || 'GoalsReport',
                        params: { goalID: res.id, engageId: engageId }
                    });
                },
                err => {
                    const { code } = err;
                    code === 'PTX_PACKAGE_LIMIT_ERROR' &&
                        this.SET_AUTH_DIALOG_VISIBLE({ visible: true, type: 'CREATE_GOAL' });
                }
            );
        },
        updateGoal() {
            const params = Object.assign({}, this.model, {
                updateBy: this.userInfo.id
            });
            // 给保存的值去除前后空格
            params.content &&
                params.content.value &&
                Array.isArray(params.content.value) &&
                (params.content.value = params.content.value.map(item => {
                    return params.content.type === 'url' && typeof item === 'string'
                        ? item.trim()
                        : item;
                }));
            delete params.content?.htmlValue;
            delete params.content?.visibleCount;
            delete params.content?.visiblePopover;
            const { from, engageId } = this.$route.params;
            analyticsService.usePTX('goal_edit').track();
            this.sendAnalytics(params.content);
            goalApis
                .updateGoal(null, {
                    data: params,
                    where: { sid: this.profileInfo.sid, id: this.$route.params.goalId },
                    republish: this.isGoalChange
                })
                .then(
                    res => {
                        this.$router.push({
                            name: from || 'GoalsReport',
                            params: { goalID: res.id, engageId: engageId }
                        });
                    },
                    err => {
                        console.log(err);
                        const { code } = err;
                        code === 'PTX_PACKAGE_LIMIT_ERROR' &&
                            this.SET_AUTH_DIALOG_VISIBLE({ visible: true, type: 'EDIT_GOAL' });
                    }
                );
        },
        formatData() {
            if (
                !['[()]', '=='].includes(this.model.content.condition) &&
                this.model.content.value.length > 0
            ) {
                this.$set(this.model.content, 'value', [this.model.content.value[0]]);
            }
            // 如果选的condition 在originalPatternList列表范围内, 则默认重置其subType为page(确保不会有 没有合参的选项的condition 出现subType为合参的情况)
            if (this.originalPatternList.includes(this.model.content.condition)) {
                this.$set(this.model.content, 'subType', 'page');
            }
        },
        handleBackClick() {
            if (isEqual(this.defaultModel, this.model)) {
                this.handleConfirmBack();
            } else {
                this.toggleDialogVisible('backDialog', true);
            }
        },
        toggleDialogVisible(type, visible) {
            this.$set(this.dialogVisible, type, visible);
        },
        handleConfirmBack() {
            const { from, back, engageId } = this.$route.params;
            this.$router.push({
                name: from || back || 'GoalsReport',
                params: { engageId: engageId },
                query: this.$route.query
            });
        },
        handleDescriptionClick() {
            this.$set(this.model, 'description', '');
        },
        async fetchEventList() {
            // 如果已有缓存，直接返回，避免重复请求
            if (this.eventNameList && this.eventNameList.length > 0) {
                return;
            }

            const [err, dictData] = await commonUtils.awaitWrap(
                this.fetchDictData({ funName: 'eventName' })
            );
            this.eventNameList = [];
            if (err || !dictData) {
                console.log('featch Event name list failed');
            } else {
                const eventName = dictData.map(item => {
                    return { code: item.key, name: item.key };
                });
                this.eventNameList = eventName;
            }
        },
        async goalTypeChange(val) {
            // 如果正在加载 goal 数据，不执行重置逻辑，避免覆盖接口返回的数据
            if (this.loading) {
                return;
            }

            if (val === 'event') {
                this.fetchEventList();
            }
            this.$set(this.model.content, 'condition', '[()]');
            this.$set(this.model.content, 'subType', 'page');
            this.$set(this.model.content, 'value', []);
            this.$set(this.model.content, 'where', []);
            this.$set(this.model.content, 'visiblePopover', false);
            this.$set(this.model.content, 'htmlValue', '');
            this.$set(this.model.content, 'visibleCount', 0);
            this.$set(this.model.content, 'aggregateType', 'user');
            this.$set(this.model.content, 'aggregateProperty', '');
            if (this.model.content.type === 'page' || this.model.content.type === 'combinedPage') {
                this.handleWord();
            }

            // 当切换到 url 类型时，默认 subType 为 page，需要预加载页面数据
            if (val === 'url' && this.pageDictData.length === 0) {
                this.fetchDictData({ funName: 'visitPage', propertyKey: 'page' }).then(res => {
                    const list = res.map(item => {
                        return { code: item.key, name: item.key };
                    });
                    this.pageDictData = list;
                });
            }
        },
        /**
         * 用户主动切换 subType 时，按需加载对应的字典数据
         */
        subTypeChange(newVal) {
            // 当 subType 为 page 时，加载页面数据
            if (newVal === 'page' && this.pageDictData.length === 0) {
                this.fetchDictData({ funName: 'visitPage', propertyKey: 'page' }).then(res => {
                    const list = res.map(item => {
                        return { code: item.key, name: item.key };
                    });
                    this.pageDictData = list;
                });
            }
            // 当 subType 为 combinedPage 时，加载组合页面数据
            else if (newVal === 'combinedPage' && this.combinedPageDictData.length === 0) {
                this.fetchDictData({
                    funName: 'visitPage',
                    propertyKey: 'combinedPage'
                }).then(res => {
                    const list = res.map(item => {
                        return { code: item.key, name: item.key };
                    });
                    this.combinedPageDictData = list;
                });
            }
        },
        /**
         * 切换condition类型时, 判断condition 是否为originalPatternList(没有合参选项的condition列表)里的,是则重置subType为page
         */
        goalConditionChange(val) {
            if (this.originalPatternList.includes(val)) {
                this.$set(this.model.content, 'subType', 'page');
            }
        },
        fetchDictData(params) {
            const { sid, timeZone } = this.profileInfo;
            const { funName, propertyKey } = params;
            return usersApis.getDictData(null, {
                where: {
                    sid,
                    funName,
                    propertyKey,
                    timeZone,
                    limit: 100
                }
            });
        },
        /**
         * Event类型的goal的value自动联想
         */
        querySearchEvent(queryString, cb) {
            var options = this.eventNameList;
            var results = queryString ? options.filter(this.createFilter(queryString)) : options;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return option => {
                return option['code']?.toLowerCase()?.indexOf(queryString?.toLowerCase()) > -1;
            };
        },
        /**
         * 获取事件列表
         */
        fetchEventPropertyList(eventName) {
            this.fetchDictData({
                funName: 'eventPropertyName',
                propertyKey: eventName ?? ''
            }).then(data => {
                const result = this.formatEventPropertyData(data);
                this.currentEventProperties = result;
                this.updateEventPropertyOptions(eventName, result);
                this.eventPropertyValueOptions = {}; // 更换事件时 其属性值的缓存清空
            });
        },
        handleToggle(status) {
            this.model.content.visiblePopover = status;
            // 当用户展开组件时，按需加载对应的数据
            if (status) {
                const subType = this.model.content.subType;
                if (subType === 'page' && this.pageDictData.length === 0) {
                    this.fetchDictData({ funName: 'visitPage', propertyKey: 'page' }).then(res => {
                        const list = res.map(item => {
                            return { code: item.key, name: item.key };
                        });
                        this.pageDictData = list;
                    });
                } else if (subType === 'combinedPage' && this.combinedPageDictData.length === 0) {
                    this.fetchDictData({
                        funName: 'visitPage',
                        propertyKey: 'combinedPage'
                    }).then(res => {
                        const list = res.map(item => {
                            return { code: item.key, name: item.key };
                        });
                        this.combinedPageDictData = list;
                    });
                }
            }
        },
        goalValueChange(val) {
            const type = this.model.content.subType;
            if (Array.isArray(val)) {
                this.$set(
                    this.model.content,
                    'value',
                    val.map(item => item.code)
                );
            } else {
                if (!val) {
                    this.$set(this.model.content, 'value', []);
                }
            }
            let v = val?.code || val || '';
            // 如果选择类型为event,则切换后请求event的自定义属性值 (如果有缓存用缓存里的)
            if (this.model.content.type === 'event') {
                this.$set(this.model.content, 'where', []);
                // 如果不是在加载数据，则重置聚合类型和属性（更换或删除事件时）
                if (!this.loading) {
                    this.$set(this.model.content, 'aggregateType', 'user');
                    this.$set(this.model.content, 'aggregateProperty', '');
                }
                // 使用防抖版本的函数，避免快速连续调用
                v && !this.eventPropertyOptions[v] && this.debouncedFetchEventPropertyList(v);
            }
            if (type === 'page' || type === 'combinedPage') {
                const htmlValue = domUtils.getConditionUrls(this.model.content);
                this.model.content.htmlValue = htmlValue;
                this.handleWord();
            }
        },
        handleWord() {
            domUtils.resetDom(this.$refs.conditionRef);
            this.$nextTick(() => {
                if (this.$refs.conditionRef) {
                    const baseEl =
                        this.model.content.subType === 'page'
                            ? this.$refs.conditionRef.querySelector('div.pageSection')
                            : this.$refs.conditionRef.querySelector('div.combinedPageSection');
                    this.$set(
                        this.model.content,
                        'visibleCount',
                        domUtils.getConditionCount(baseEl)
                    );
                }
            });
        },
        formatEventPropertyData(data) {
            const result = [];
            data.map(item => {
                const { type, key } = item;
                const defaultCondition = type === 'TIME' ? '>=' : '==';
                const valueNeedQuery = type === 'STRING';
                result.push({
                    ...item,
                    name: key, // 添加name字段是为了跟usergroup里的保持一样
                    defaultCondition,
                    valueNeedQuery,
                    allowCreate: type === 'STRING',
                    blurCreate: type === 'STRING',
                    notDisableDate: true
                });
            });
            return result;
        },
        updateEventPropertyOptions(key, value) {
            if (this.eventPropertyOptions.hasOwnProperty(key)) {
                this.eventPropertyOptions[key] = value;
            }
        },
        handleAddEventVariant() {
            if (!this.canAddSubject || !this.canAddEventVariant) {
                return;
            }

            const newWhere = cloneUtils.deep(this.model.content?.where || []);
            newWhere.push({
                key: '',
                condition: '',
                type: '',
                value: []
            });
            this.$set(this.model.content, 'where', newWhere);
        },
        handleCacheValueOptions(key, value) {
            this.eventPropertyValueOptions[key] = value;
        },
        handleUpdateWhere(index, value) {
            this.model.content.where[index] = value;
        },
        handleDeleteEventVariant(index) {
            this.model.content.where.splice(index, 1);
        },
        handleAggregateTypeChange(val) {
            // 当切换为 user 时，清空聚合属性
            if (val === 'user') {
                this.$set(this.model.content, 'aggregateProperty', '');
            }
        },
        // 当事件被删除或没有 NUMBER 类型属性时，重置聚合类型为 user
        resetAggregateTypeIfNeeded() {
            const eventValue = this.model.content.value;
            const hasNoEvent = !eventValue || eventValue[0] === '';

            // 编辑模式下，如果有事件值但属性列表还没加载完成，不执行重置
            // 避免 getGoal 返回后但 fetchEventPropertyList 还在请求中时误重置 aggregateType
            const isEventType = this.model.content.type === 'event';
            const isEventPropertiesLoading =
                !this.isCreated &&
                isEventType &&
                !hasNoEvent &&
                this.currentEventProperties === null;

            if (isEventPropertiesLoading) {
                return;
            }

            const hasNoNumberProperty =
                !this.numberTypeEventProperties || this.numberTypeEventProperties.length === 0;
            if (
                (hasNoEvent || hasNoNumberProperty) &&
                ['sum', 'average'].includes(this.model.content.aggregateType)
            ) {
                this.$set(this.model.content, 'aggregateType', 'user');
                this.$set(this.model.content, 'aggregateProperty', '');
            }
        }
    },
    components: {
        BackDialog,
        PageHeader,
        GoalEventVariant,
        ItemMultiSelectWithPopover
    }
};
</script>
<style lang="scss" module>
@import '@/styles/import.scss';

$arrow-width: 10px;
$arrow-height: 13px;

$item-min-width: 182px;
$item-close-btn-width: 58px;

:global {
    .setting-description-enter-active,
    .setting-description-leave-active {
        opacity: 1;
        transform: scaleY(1);
        transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1),
            opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);
        transform-origin: center top;
    }

    .setting-description-enter,
    .setting-description-leave-active {
        opacity: 0;
        transform: scaleY(0);
    }
}

.setting {
    padding-bottom: 260px;

    .header {
        padding-bottom: 0;

        &-tools {
            display: flex;
            align-items: center;

            & > svg {
                margin-right: 18px;
                cursor: pointer;
                fill: $pt-black-600;

                &:hover {
                    fill: $pt-black-600;
                }
            }
        }
    }

    .description {
        margin-top: $arrow-height + 18px;
        position: relative;

        @include media-lg {
            .description-icon {
                min-width: 100px;

                img {
                    width: 90px !important;
                    height: 90px !important;
                }
            }

            &-custom .description-icon img {
                width: 50px !important;
                height: 50px !important;
            }
        }

        @include media-md {
            .description-icon {
                display: none;
            }
        }

        &-close {
            cursor: pointer;
            position: absolute;
            top: 16px;
            right: 16px;
            fill: $pt-black-90;

            &:hover {
                fill: $pt-black-300;
            }
        }

        &-custom {
            .description-icon img {
                width: 60px !important;
                height: 60px !important;
            }
        }

        &-arrow {
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 10px $arrow-height 10px;
            border-color: transparent transparent $pt-black-30 transparent;
            position: absolute;
            top: -($arrow-height - 1px);
            z-index: 1;

            &::after {
                content: '';
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 0 $arrow-width - 1px $arrow-height - 1px $arrow-width - 1px;
                border-color: transparent transparent $pt-black-30 transparent;
                position: absolute;
                left: -($arrow-width - 1px);
                top: 1px;
            }
        }

        &-container {
            padding: 54px 54px 36px 48px;
            background-color: $pt-black-30;
            border-radius: 4px;
            display: flex;
            position: relative;
            border: 1px solid $pt-black-30;
        }

        &-icon {
            flex: 0 0 14%;
            min-width: 130px;
            max-width: 125px;

            img {
                width: 70px;
            }
        }

        &-info {
            h3,
            h4,
            h5 {
                color: $pt-black-600;
                font-size: 20px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 29px;
            }

            h4,
            h5 {
                font-size: 16px;
                line-height: 24px;
            }

            h5 {
                color: $pt-black-600;
                font-size: 12px;
                margin-top: 26px;
            }

            p,
            span,
            a {
                color: $pt-black-600;
                font-size: 14px;
                font-weight: 300;
                letter-spacing: 0;
                line-height: 20px;
                margin-top: 6px;
            }

            span,
            a {
                font-size: 12px;
                margin-top: 4px;
            }

            a {
                display: block;
                cursor: pointer;
                text-decoration: underline;

                &:hover {
                    text-decoration: none;
                }
            }
        }

        &-items {
            border-top: 1px solid $pt-black-50;
            margin-top: 16px;
            padding-top: 16px;
            display: grid;
            grid-auto-flow: column;
            grid-column-gap: 32px;
            grid-row-gap: 16px;

            @include media-md {
                .description-item {
                    grid-column-start: span 2;
                }
            }

            @include media-lg {
                // grid-auto-flow: row;
                // grid-template-columns: repeat(2, 1fr);

                .description-item:first-child {
                    grid-column-start: span 2;
                }
            }
        }
    }

    .container {
        margin-top: 52px;
    }

    .box {
        margin-bottom: 20px;

        & > h4 {
            color: $pt-black-600;
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 22px;
        }

        & > button {
            margin: 16px 0 28px;
        }

        &-content {
            margin-top: 8px;
            display: flex;
            gap: 8px;

            .content_item {
                .helpIcon {
                    width: 16px;
                    height: 16px;
                    fill: $pt-black-600;
                    margin-left: 4px;
                    vertical-align: text-bottom;
                }
            }

            .content_item_pagetype {
                flex: 0 0 180px;

                :global {
                    .el-select {
                        width: 100%;
                    }
                }

                ~ .content_item_value {
                    flex: 1;
                    max-width: calc(100vw - 3 * 180px - 96px - 3 * 8px);
                }
            }

            .content_item_value {
                flex: 0 0 480px;
            }

            .iconButton {
                display: inline-block;
                width: 32px;
                min-width: 32px;
                height: 32px;
                padding: 4px;
                border-radius: 3px;
                margin-left: 8px;

                &:hover {
                    background-color: $pt-black-40;
                }

                svg {
                    width: 24px;
                    height: 24px;
                    fill: #5b6c86;
                }
            }
        }

        .eventVariant {
            padding-left: 30px;
        }

        .rexTips {
            max-width: 810px;
            padding: 12px 16px;
            border-radius: 4px;
            border: 1px solid #a6c8ff;
            background-color: $pt-gray-10;
            color: #344563;
            margin-top: 10px;
            font-size: 12px;

            h3 {
                font-size: 13px;
                font-weight: 500;
                margin-bottom: 4px;
            }

            p {
                line-height: 20px;
            }

            a {
                color: $pt-green-60;
                @extend %link;

                &:hover {
                    color: $pt-green-60;
                }
            }
        }

        &-ipt {
            width: 100%;
            max-width: 400px;
        }

        &-textarea {
            height: 62px;
            max-width: 520px;
        }
    }

    .filter-add {
        border: none;
        background: transparent;
        @include link($pt-green-60, $pt-green-70);
    }

    .overview {
        margin-top: 68px;
        padding-bottom: $page-content-padding-bottom * 2;

        &-title {
            color: $pt-black-600;
            display: flex;
            flex-direction: column;
            margin-bottom: 60px;

            h4 {
                font-size: 16px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 24px;
            }

            p {
                margin-top: 10px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0;
                line-height: 19px;
                display: flex;
                align-items: center;

                i {
                    width: 1px;
                    height: 24px;
                    background-color: $pt-black-300;
                    margin: 0 20px;
                }
            }

            span {
                color: $pt-green-60;
                font-size: 28px;
                font-weight: 400;
                letter-spacing: 0;
                line-height: 38px;
                margin-left: 10px;
            }
        }

        &-box {
            box-sizing: border-box;
            height: 284px;
            border: 1px solid $pt-black-40;
            border-radius: 2px;
            background-color: $pt-white;

            &:not(:last-child) {
                margin-bottom: 40px;
            }
        }

        &-list {
            min-width: 600px;

            .row {
                color: $pt-black-600;
                font-size: 14px;
                line-height: 24px;
                display: grid;
                grid-template-columns: repeat(12, 1fr);
                border-top: 1px solid $pt-black-40;
                padding: 30px 0;

                &-header {
                    padding: 0;
                    border-top: none;
                    height: 30px;
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 19px;
                }

                &:hover:not(.row-header) {
                    background-color: $pt-black-20;
                }
            }

            .cell {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                padding-right: 6px;

                &.icon {
                    @extend %flex-center;
                    padding: 0;

                    span {
                        height: 32px;
                        width: 32px;
                        border-radius: 50%;
                        color: $pt-white;
                        font-size: 16px;
                        letter-spacing: 0;
                        @extend %flex-center;
                    }
                }

                &.email {
                    font-size: 16px;
                }

                &-span1 {
                    grid-column-start: span 1;
                }

                &-span2 {
                    grid-column-start: span 2;
                }

                &-span3 {
                    grid-column-start: span 3;
                }
            }

            .lenTips {
                font-size: 12px;
                text-align: left;
                padding: 10px 0;
                color: $pt-black-60;
            }
        }
    }
}

.type {
    flex: 0 0 180px;
}

.buttonFilter {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
        svg {
            fill: $pt-black-600;
        }
    }

    svg {
        width: 20px;
        height: 20px;
        fill: $pt-black-300;
    }

    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;

        svg {
            fill: $pt-black-90;
        }
    }
}

.disabledOption {
    display: block;
    width: 100%;
    cursor: not-allowed;
}

.aggregatePropertySelect {
    flex: 0 0 180px;

    :global {
        .el-select {
            width: 100%;
        }
    }
}

.subjects {
    width: 100%;
    display: flex;
    &.hasSubjects {
        margin-top: 16px;
    }

    :global {
        [aria-label='subject-key'],
        [aria-label='subject-operator'] {
            flex: 0 0 180px;
        }

        [aria-label='subject-value'] {
            flex: 1;
            max-width: calc(100vw - 180px * 3 - 24px - 96px);
        }
    }

    .subjectsGap {
        flex: 0 1 $item-min-width;
        min-width: $item-min-width;
    }

    .subjectsContent {
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding-left: 4px;
        border-left: 4px solid $pt-black-40;
    }

    .subjectsTag {
        display: inline-block;
        height: 24px;
        line-height: 24px;
        color: $pt-black-50;
        font-size: 12px;
        padding: 0 10px;
    }
}

.subject-tips {
    max-width: 400px;
    line-height: 24px;

    a {
        color: #fff;
        text-decoration: underline;

        &:hover {
            color: #fff;
        }
    }
}
</style>
